import { useQuery } from "@tanstack/react-query";
import { useHousehold } from "@/context/HouseholdContext";
import { api } from "@/lib/api";

export const useGoals = () => {
  const { active } = useHousehold();
  return useQuery({
    queryKey: ["goals", active?.id],
    queryFn: () => api.get(`/households/${active.id}/goals`).then((r) => r.data),
    enabled: !!active,
    retry: false,
  });
};
